import TreatmentPlanObjectivesV1 from "../../../../components/form_builder/elements/treatment_plan_objectives/TreatmentPlanObjectivesV1.vue";

export default {
  componentName: "fb-treatment-plan-objectives-v1",
  component: TreatmentPlanObjectivesV1,
  defaultAttrs: {
    properties: {
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    width: 120,
    template: () => ""
  },
  validate: () => {
    const errors = [];
    return errors;
  }
};
